var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{staticClass:"account-setting-vue frame-flex-page h-panel"},[_c('div',{staticClass:"frame-left"},[_c('sub-menu',{attrs:{"datas":_vm.menus}})],1),_c('div',{staticClass:"frame-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }